import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// i18n wired from day one (commandment 6) — en-GB shipped, adding a locale
// means adding files here, never touching components. Namespaces are
// per-feature locale files (docs/13).
const namespaces = import.meta.glob('../locales/en-GB/*.json', { eager: true }) as Record<
  string,
  { default: Record<string, string> }
>;

const resources: { 'en-GB': Record<string, Record<string, string>> } = { 'en-GB': {} };
for (const [path, module] of Object.entries(namespaces)) {
  const ns = path.split('/').pop()?.replace('.json', '') ?? 'common';
  resources['en-GB'][ns] = module.default;
}

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en-GB',
  fallbackLng: 'en-GB',
  defaultNS: 'common',
  ns: Object.keys(resources['en-GB']),
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
